import { createFileRoute } from '@tanstack/react-router'
import { Metrics } from 'pages/metrics/Metrics'
import { metricsSearchSchema } from 'pages/metrics/searchSchema'

export const Route = createFileRoute('/fimmetrics')({
  component: Metrics,
  validateSearch: metricsSearchSchema,
  staticData: {
    title: 'FIM Metrics',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: true,
    },
  },
})
